import { Header } from '../landing/components/Header';
import { NewLandingBody } from './NewLandingBody';

export function NewPage() {
	return (
		<>
			<Header />
			<NewLandingBody />
		</>
	);
}
